import { Component, Input } from '@angular/core';

@Component({
	selector: 'eif-user-name-label',
	template: `
		<div class="user-name-label">
			@if (userName) {
				<div
					[eifTooltip]="userName"
					class="user-name-label-name truncate">
					{{ userName }}
				</div>
			}
			@if (userEmail) {
				<div
					[eifTooltip]="userEmail"
					class="user-name-label-email truncate">
					{{ userEmail }}
				</div>
			}
		</div>
	`,
	styles: [
		`
			.user-name-label {
				display: flex;
				flex-direction: column;
				padding: 1rem 1rem 0.5rem;
				max-width: 250px;
			}
			.user-name-label-name {
				font-weight: 600;
				font-size: 1rem;
				color: var(--primary-color);
			}
			.user-name-label-email {
				font-size: 0.75rem;
				color: var(--neutral-color);
				font-style: italic;
			}
		`,
	],
	standalone: false,
})
export class UserNameLabelComponent {
	@Input() userName: string;
	@Input() userEmail: string;
}
